import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiX, FiCopy } from 'react-icons/fi';
import './CellValueModal.css';

const CellValueModal = ({ value, columnName, onClose }) => {
    const { t } = useTranslation();
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    // 값을 안전하게 문자열로 변환
    const displayValue = typeof value === 'object'
        ? JSON.stringify(value, null, 2)
        : String(value);

    const handleCopy = () => {
        navigator.clipboard.writeText(displayValue);
    };

    return (
        <div className="cell-value-modal-backdrop" onClick={handleBackdropClick}>
            <div className="cell-value-modal">
                <div className="cell-value-modal-header">
                    <h3>{columnName}</h3>
                    <div className="cell-value-modal-actions">
                        <button onClick={handleCopy} className="copy-button" title={t('common:cv.copyToClipboard')}>
                            <FiCopy size={13} style={{ verticalAlign: 'middle', marginRight: 4 }} />{t('common:cv.copy')}
                        </button>
                        <button onClick={onClose} className="close-button">
                            <FiX size={16} />
                        </button>
                    </div>
                </div>
                <div className="cell-value-modal-content">
                    <pre>{displayValue}</pre>
                </div>
                <div className="cell-value-modal-footer">
                    <div className="value-info">
                        {t('common:cv.length', { n: displayValue?.length || 0 })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CellValueModal;
